import http from "./httpService";

const apiEndpoint = "/client/account";

function accountUrl(username) {
  return `${apiEndpoint}/${username}`;
}

export function getAccounts(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getAccountNav(params = {}) {
  return http.get(`${apiEndpoint}/nav`, { params });
}

export function getCounters() {
  return http.get(`/client/counters/`);
}

export function getOnlineAccounts() {
  return http.get(`${apiEndpoint}/online/`);
}

export function getCustomerAccounts() {
  return http.get(`${apiEndpoint}/`);
}

export function getAccount(username) {
  // return http.get(accountUrl(username));
  return http.get(`${apiEndpoint}/${username}`);

}

export function saveAccount(account) {
  if (account.id) {
    const body = { ...account };
    delete body.id;
    return http.put(accountUrl(account.username), body);
  }

  return http.post(apiEndpoint, account);
}

export function deleteAccount(username) {
  return http.delete(accountUrl(username));
}
